import { useIntl } from 'react-intl'
import TextLink from 'LuxKit/TextLink'
import Sheet from 'components/utils/Sheet'
import Group from 'components/utils/Group'
import Divider from 'LuxKit/Divider'
import Caption from 'LuxKit/Typography/Caption'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  rawContent: string
  oaiConversationId?: string
}

const OPENAI_LOGS_BASE_URL = 'https://platform.openai.com/logs'

function DevAssistantRawBlock({ rawContent, oaiConversationId }: Props) {
  const intl = useIntl()
  if (!rawContent.trim()) {
    return null
  }
  return (
    <Sheet background="neutral-seven" border="neutral-five" borderRadius="M">
      <Group direction="vertical" gap={0} fullWidth>
        <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center" fullWidth>
          <Sheet padding="8 12">
            <Caption variant="medium" format="uppercase" colour="neutral-two">
              {intl.formatMessage({
                id: 'eugL2EYNioisTs5xTdtP',
                defaultMessage: 'Full model output',
                description: 'Label for the full raw model output section in the dev assistant chat',
              })}
            </Caption>
          </Sheet>
          {oaiConversationId && (
            <Sheet padding="8 12">
              <TextLink
                href={`${OPENAI_LOGS_BASE_URL}/${oaiConversationId}`}
                target="_blank"
                size="small"
              >
                {intl.formatMessage({
                  id: 'SylpH6xOi9jG8DIL09t1',
                  defaultMessage: 'View OpenAI Logs ↗',
                  description: 'Dev mode link to view OpenAI conversation logs externally',
                })}
              </TextLink>
            </Sheet>
          )}
        </Group>
        <Divider kind="secondary" />
        <Sheet padding={12}>
          <BodyText variant="small" weight="bold" as="pre" wrap="pre-wrap" colour="neutral-two">
            {rawContent}
          </BodyText>
        </Sheet>
      </Group>
    </Sheet>
  )
}

export default DevAssistantRawBlock
